import React from 'react';
import { graphql, Link, StaticQuery } from 'gatsby';
import logo from '../images/logo.svg';
import { PATHS } from '../utils/urls';

const Footer = props => (
  <div className="footer-strip" id="footer-strip">
    <div className="container">
      {/* <div className="row">
        <div> */}
      <div className="footer row justify-content-center justify-content-md-between align-items-end flex-md-nowrap">
        <div className="footerLinks sectionSpacing">

          <div className="ulContainer">
            <div className="ulContainerCH1">
              <h3 className="d-none d-md-block"><img alt="ChartHop" src={logo} /></h3>
              <ul className="social">
                <li><a href="https://www.linkedin.com/company/charthop" target="_blank" rel="noopener noreferrer"><span hidden> linkedin</span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" /></svg></a></li>
                <li><a href="https://twitter.com/charthop" target="_blank" rel="noopener noreferrer"><span hidden> twitter</span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-.139 9.237c.209 4.617-3.234 9.765-9.33 9.765-1.854 0-3.579-.543-5.032-1.475 1.742.205 3.48-.278 4.86-1.359-1.437-.027-2.649-.976-3.066-2.28.515.098 1.021.069 1.482-.056-1.579-.317-2.668-1.739-2.633-3.26.442.246.949.394 1.486.411-1.461-.977-1.875-2.907-1.016-4.383 1.619 1.986 4.038 3.293 6.766 3.43-.479-2.053 1.08-4.03 3.199-4.03.943 0 1.797.398 2.395 1.037.748-.147 1.451-.42 2.086-.796-.246.767-.766 1.41-1.443 1.816.664-.08 1.297-.256 1.885-.517-.439.656-.996 1.234-1.639 1.697z" /></svg></a></li>
                <li><a href="https://www.facebook.com/ChartHop/" target="_blank" rel="noopener noreferrer"><span hidden> facebook</span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-3 7h-1.924c-.615 0-1.076.252-1.076.889v1.111h3l-.238 3h-2.762v8h-3v-8h-2v-3h2v-1.923c0-2.022 1.064-3.077 3.461-3.077h2.539v3z" /></svg></a></li>
                <li><a href="https://www.instagram.com/charthop/" target="_blank" rel="noopener noreferrer"><span hidden> instagram</span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 
                24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg></a></li>
                <li><a href="https://www.youtube.com/channel/UCiC6zx3_KlEuqXdu2VDmHaA" target="_blank" rel="noopener noreferrer"><span hidden> youtube</span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g><polygon points="10.505 14.248 14.409 12 10.505 9.752 10.505 14.248"/><path d="M19,0H5A5.00056,5.00056,0,0,0,0,5V19a5.00056,5.00056,0,0,0,5,5H19a4.9999,4.9999,0,0,0,5-5V5A4.9999,4.9999,0,0,0,19,0Zm.49817,12.01227a19.80548,19.80548,0,0,1-.30872,3.60718,1.879,1.879,0,0,1-1.32184,1.32165A45.60917,45.60917,0,0,1,12,17.25a43.97671,43.97671,0,0,1-5.86761-.32117A1.87919,1.87919,0,0,1,4.81055,15.607,19.71855,19.71855,0,0,1,4.50165,12a19.79245,19.79245,0,0,1,.3089-3.607A1.91714,1.91714,0,0,1,6.13239,7.0589,45.60917,45.60917,0,0,1,12,6.75a43.88338,43.88338,0,0,1,5.86761.32117A1.87919,1.87919,0,0,1,19.18945,8.393,18.79484,18.79484,0,0,1,19.49817,12.01227Z"/></g></svg></a></li>
              </ul>
              <div className="segment-FooterContent ulContainerCH2 mb-1">
                <img src="/footer/AICPA_SOC.svg" alt="AICPA SOC"></img>
                <p className="copyright mb-0">ChartHop, Inc. has successfully completed a SOC 2 Type 2 examination by Schellman & Company.</p>
              </div>
            </div>

            <div className="footer-menus ulContainerCH1-2">
              <ul className="footer-menu">
                <div>
                  <li>
                    {' '}
                    <Link to={PATHS.PRIVACY_POLICY}>Privacy&nbsp;Policy</Link>
                  </li>
                  <li>|</li>
                  <li>
                    {' '}
                    <Link to={PATHS.SECURITY}>Security</Link>
                  </li>
                </div>
                <li className="copyright">
                  ©
                    {' '}
                  {new Date().getFullYear()}
                  {' '}
                  {props.data.site.siteMetadata.title}, Inc. All Rights Reserved.
                  </li>
              </ul>
            </div>
          </div>


          <div>
            <ul>
              <li>
                Platform
              </li>
              <li>
              <Link to={PATHS.WHY_CHARTHOP}>Why ChartHop</Link>
              </li>
              <li>
              <Link to={PATHS.OVERVIEW}>Platform Overview </Link>
              </li>
              <li>
              <Link to={PATHS.ORG_CHART}>Org Chart</Link>
              </li>
              <li>
              <Link to={PATHS.REPORTING}>Reporting</Link>
              </li>
              <li>
              <Link to={PATHS.PLANNING}>Headcount Planning</Link>
              </li>
              <li>
              <Link to={PATHS.COMPENSATION}>Compensation</Link>
              </li>
              <li>
              <Link to={PATHS.PERFORMANCE}>Performance</Link>
              </li>
              <li>
              <Link to={PATHS.DEI}>DE&I</Link>
              </li>
              <li>
              <Link to={PATHS.EMPLOYEE_EXP}>Employee Experience</Link>
              </li>
              <li>
              <Link to={PATHS.INTEGRATIONS}>Integrations</Link>
              </li>
              <li>
              <Link to={PATHS.SECURITY}>Security</Link>
              </li>
{/*              <li>
              <Link to={PATHS.CONNECT}>Connect </Link>
              </li>*/}
            </ul>
            <ul>
              <li>
              Company
            </li>
              <li>
                <Link to={PATHS.ABOUT}>About</Link>
                </li>
              <li>
                <a href="/company/careers/" target="_blank" rel="noopener noreferrer" >Careers</a>
                </li>
              <li>
                <Link to={PATHS.INVESTORS}>Investors</Link>
              </li>
              <li>
                <Link to={PATHS.LEADERSHIP}>Leadership</Link>
              </li>
              <li>
                <Link to={PATHS.PRESS}>Press</Link>
              </li>
              <li>
                <Link to={PATHS.CONTACTUS}>Contact Us</Link>
              </li>
            </ul>
            <ul>
              <li>
                Resources
              </li>
              <li>
                <Link to={PATHS.RESOURCES}>Resources Overview</Link>
              </li>
              <li>
                <Link to={PATHS.CUSTOMER_STORIES}>Customers Stories</Link>
              </li>
              <li>
                <Link to={PATHS.BLOG}>Blog</Link>
              </li>
              <li>
                <a href="https://docs.charthop.com/" target="_blank" rel="noopener noreferrer">Support Documentation</a>
              </li>
              <li>
                <Link to={PATHS.VIDEOS}>Videos</Link>
              </li>
            </ul>
            <ul>
              <li>
                <Link to={PATHS.PRICING}><span className="pricing-footer">Pricing</span></Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div >
);

export default props => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => <Footer data={data} />}
  />
);
